export default __webpack_public_path__ + "static/media/brand.271bb918.png";